$(document).ready(function() {
  if ($(".seccion-contacto").get(0) == null) {
    return
  }

  $('#formContacto').validarForm((form) => {

    $("#btnGeneral").loader("show")

    var formData = new FormData(form)
    axios
      .post('/contacto', formData)
      .then((respuesta) => {
        $("#btnGeneral").loader("hide")

        if (respuesta.data.error) {
          swal({
            icon: "info",
            title: respuesta.data.error,
            button: {
              text: "Aceptar",
              closeModal: true,
            },
          })
          return
        }
        swal({
          icon: "success",
          title: "Mensaje enviado correctamente",
          button: {
            text: "Aceptar",
            closeModal: true,
          },
        })
        $("#formContacto")[0].reset()
      })
      .catch((error) => {
        ReportErrorLog(error)
        console.error(error)
        $("#btnGeneral").loader("hide")
        swal({
          icon: "warning",
          title: "Ocurrió un error inesperado",
          button: {
            text: "Aceptar",
            closeModal: true,
          },
        })
      })

  })

});
